import * as React from 'react'
const SvgComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 154 120"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#clip0_26613_135)">
      <path fill="#fff" d="M130.28 25.882H32.017v93.733h98.263V25.882Z" />
      <path d="M31.918 25.882H13.566v93.733h18.352V25.882Z" opacity={0.5} />
      <path
        fill="#fff"
        d="M79.391 2.084a.994.994 0 1 1 0-1.988.99.99 0 0 1 .995.994.99.99 0 0 1-.995.994Z"
      />
      <path
        d="M130.291 25.882H23.294L31.912-.335h79.503c5.496 0 10.407 3.42 12.324 8.568l6.552 17.65Z"
        opacity={0.75}
      />
      <path d="M80.938 31.992a6.896 6.896 0 0 1 6.894 6.894v14.059H74.044v-14.06a6.896 6.896 0 0 1 6.894-6.893ZM80.938 61.402a6.896 6.896 0 0 1 6.894 6.894v14.059H74.044V68.296a6.896 6.896 0 0 1 6.894-6.894ZM80.938 90.812c5.408 0 9.8 4.392 9.8 9.8v19.009H71.144v-19.009c0-5.408 4.392-9.8 9.8-9.8h-.006ZM110.393 31.992a6.896 6.896 0 0 1 6.894 6.894v14.059h-13.788v-14.06a6.896 6.896 0 0 1 6.894-6.893ZM110.393 61.402a6.896 6.896 0 0 1 6.894 6.894v14.059h-13.788V68.296a6.896 6.896 0 0 1 6.894-6.894ZM110.393 90.812a6.896 6.896 0 0 1 6.894 6.895v14.058h-13.788V97.707a6.896 6.896 0 0 1 6.894-6.895ZM51.484 31.992a6.896 6.896 0 0 1 6.894 6.894v14.059H44.59v-14.06a6.896 6.896 0 0 1 6.894-6.893ZM51.484 61.402a6.896 6.896 0 0 1 6.894 6.894v14.059H44.59V68.296a6.896 6.896 0 0 1 6.894-6.894ZM51.484 90.812a6.896 6.896 0 0 1 6.894 6.895v14.058H44.59V97.707a6.896 6.896 0 0 1 6.894-6.895ZM32.017 25.882V-.379a12.606 12.606 0 0 0-11.822 8.225l-6.684 18.036h18.506Z" />
      <path
        d="M151.172 105.004c-2.226-1.724-4.226-3.922-6.591-5.447-2.27-1.508-4.888-2.403-7.612-3.17 2.563-2.763 7.099-2.669 10.12-.642 2.994 1.967 4.773 5.718 4.083 9.259ZM134.616 95.955c-1.022-2.624-1.602-5.54-2.845-8.06-1.171-2.463-2.955-4.579-4.894-6.64 3.618-1.043 7.458 1.37 9.004 4.663 1.553 3.232 1.149 7.358-1.265 10.037Z"
        opacity={0.75}
      />
      <path
        d="M153.022 91.912c-1.105-.127-2.099-.343-3.187-.47-1.84-.21-3.679-.154-5.436.381-2.74.79-5.579 2.591-8.253 3.873.398-4.861 5.099-8.938 10.048-8.59 2.95.204 5.712 2.044 6.823 4.8l.005.006ZM140.609 110.362c-1.314-1.972-2.099-3.955-2.933-6.109a47.875 47.875 0 0 1-1.839-6.121c-.078-.337-.155-.68-.238-1.072.779 0 1.475.243 2.16.553 1.287.63 2.348 1.63 3.127 2.817 1.928 2.933 2.126 7.198-.277 9.927v.005ZM133.876 96.436c-2.331-.437-4.298-1.254-6.425-2.16a47.731 47.731 0 0 1-5.668-2.95c-.298-.182-.596-.359-.933-.58.541-.558 1.204-.89 1.9-1.16 1.348-.48 2.806-.547 4.204-.276 3.447.663 6.64 3.497 6.922 7.12v.006Z"
        opacity={0.75}
      />
      <path d="M126.048 119.615h10.446s-9.137-8.927-1.154-23.113c0 0-15.043 7.209-9.292 23.113Z" />
    </g>
    <defs>
      <clipPath id="clip0_26613_135">
        <path fill="#fff" d="M0 0h154v120H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
